import { Form, Input, Switch, InputNumber, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { StarFilled, HeartFilled, LikeFilled, SmileFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const PREVIEW_ICON = {
    star: <StarFilled className="text-[#FAAD14] text-2xl" />,
    heart: <HeartFilled className="text-[#EB2F96] text-2xl" />,
    thumb: <LikeFilled className="text-[#1890ff] text-2xl" />,
    emoji: <SmileFilled className="text-[#FAAD14] text-2xl" />,
};

const RatingForm = ({ formValues }) => {
    const ratingType = formValues?.ratingType || "star";
    const count = Math.min(Math.max(Number(formValues?.count) || 5, 1), 10);
    const icon = PREVIEW_ICON[ratingType] || PREVIEW_ICON.star;
    const { t } = useTranslation();

    const RATING_TYPE_OPTIONS = [
        {
            value: "star",
            label: (
                <span className="flex items-center gap-1.5">
                    <StarFilled className="text-[#FAAD14]" />
                    {t("Stars")}
                </span>
            ),
        },
        {
            value: "heart",
            label: (
                <span className="flex items-center gap-1.5">
                    <HeartFilled className="text-[#EB2F96]" />
                    {t("Hearts")}
                </span>
            ),
        },
        {
            value: "thumb",
            label: (
                <span className="flex items-center gap-1.5">
                    <LikeFilled className="text-[#1890ff]" />
                    {t("Thumbs Up")}
                </span>
            ),
        },
        {
            value: "emoji",
            label: (
                <span className="flex items-center gap-1.5">
                    <SmileFilled className="text-[#FAAD14]" />
                    {t("Emojis")}
                </span>
            ),
        },
    ];

    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="ratingType" label={t("Rating Type")} initialValue="star">
                <Select options={RATING_TYPE_OPTIONS} placeholder={t("Select type")} />
            </Form.Item>

            <Form.Item name="count" label={t("Max Count")} initialValue={5}>
                <InputNumber min={1} max={10} style={{ width: "100%" }} />
            </Form.Item>

            {/* Live preview */}
            <div className="bg-gray-50 border border-gray-200 rounded-lg py-2.5 px-3.5 mb-4 flex items-center gap-1">
                {Array.from({ length: count }).map((_, i) => (
                    <span key={i} className={`transition-opacity duration-200 ${i === 0 ? "opacity-100" : "opacity-30"}`}>
                        {icon}
                    </span>
                ))}
            </div>

            <Form.Item name="allowHalf" label={t("Allow Half")} className="horizontal-form-item" valuePropName="checked">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="tooltip" label={t("Tooltip")} className="horizontal-form-item" valuePropName="checked">
                <Switch size="small" />
            </Form.Item>

            {formValues?.tooltip && (
                <Form.Item label={t("Help Text")} name="helpText">
                    <TextArea rows={2} placeholder={t("Enter help text")} />
                </Form.Item>
            )}

            <Form.Item name="mandatory" label={t("Mandatory")} className="horizontal-form-item" valuePropName="checked">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t("Read Only")} className="horizontal-form-item" valuePropName="checked">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item" valuePropName="checked">
                <Switch size="small" />
            </Form.Item>
        </>
    );
};

export default RatingForm;
